import { Reducer } from 'redux';
import { AdminSearchActionTypes, AdminSearchState } from './types';

// 初期状態
export const initialState: AdminSearchState = {
  checkBoxValues: ['1'], // デフォルトの検索条件で「未対応」が選択された状態にする
};

const reducer: Reducer<AdminSearchState> = (
  state: AdminSearchState = initialState,
  action,
): AdminSearchState => {
  switch (action.type) {
    case AdminSearchActionTypes.UPDATE: {
      const newState: AdminSearchState = action.payload;
      return newState;
    }
    default:
      return state;
  }
};

export { reducer as adminSearchReducer };
